import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'mlp-ng-button-icon',
    templateUrl: './button-icon.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ButtonIconSharedComponent {
    @Input() disabled = false;
    @Input() btnSize: 'large' | 'medium' | 'xsmall' | 'small' = 'medium';
    @Input() btnIcon: string;
    @Input() btnIconClass: string;
    @Input() btnStyle: 'secondary' | 'tertiary';
    @Input() btnShadow = false;
    @Input() btnType: 'submit' | 'button' | 'reset' = 'button';
    @Input() fullWidth = false;
    @Input() label: string;
    @Input() labelSecondary: string;
}
